export enum SortCriteria {
  BY_CODE = "BY_CODE",
  ALPHABETICALLY = "ALPHABETICALLY",
  CHRONOLOGICALLY = "CHRONOLOGICALLY"
}
